import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-4 yui3-normalized" }
const _hoisted_3 = {
  key: 0,
  class: "pt-8 my-8 border-t"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "mb-4 text-4xl" }, "Topics", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_markdown = _resolveComponent("markdown")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_markdown, {
        source: _ctx.chapter.description
      }, null, 8, ["source"])
    ]),
    (_ctx.chapter.topics)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chapter.topics, (topic, topicIndex) => {
            return (_openBlock(), _createBlock("button", {
              class: "p-1 mr-2 text-black border rounded focus:outline-none bg-highlight",
              key: topicIndex,
              onClick: ($event: any) => (_ctx.handleTopicClick(topic))
            }, _toDisplayString(topic.title), 9, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}